/*
Create booking
*/
export async function postFile(booking:Booking, imageData:any) {
    console.log('post-file.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:''};
    if(process.env.NODE_ENV === 'development') {
        return {
            'error':false,
            'data': imageData
        }
        /*return {
           'error':true,
           'data': 'Uppladdningsfel: Endast JPEG/JPG/PNG-filer tillåtna.'
        }*/
    } else {
        let data = new FormData();
        data.append('action', 'react_data');
        data.append('call', 'upload image');
        data.append('booking', JSON.stringify(booking));
        data.append('image', imageData);
        return await fetch(reactAppData.api_url, {body:data, method:'post'})
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('result', result)
                    return result
                },
                (error) => {
                    return {error:error}
                }
            );
    }
}
